<template>
  <div class="portal-product-attribution pa-4 text-center text-caption flex-shrink-0">
    <p class="mb-0 d-flex align-center justify-center flex-wrap ga-2">
      <span class="portal-product-attribution__lead">Un producto de</span>
      <a
        href="https://www.macena.com.ar/"
        target="_blank"
        rel="noopener noreferrer"
        class="portal-product-attribution__link d-inline-flex align-center"
      >
        <img :src="macenaLogoSrc" alt="Macena" />
      </a>
    </p>
  </div>
</template>

<script>
import macenaLogo from '../../assets/img/macena_gray.svg'

export default {
  name: 'PortalProductAttribution',
  data() {
    return {
      macenaLogoSrc: macenaLogo,
    }
  },
}
</script>

<style scoped>
.portal-product-attribution {
  background: rgb(var(--v-theme-background));
}
/* Mismo gris que `macena_gray.svg` / pie Geclisa Web (`Footer.vue`). */
.portal-product-attribution__lead {
  color: #707070;
  font-size: 14px;
}
.portal-product-attribution__link {
  line-height: 0;
}
.portal-product-attribution__link img {
  display: block;
  height: 13px;
  width: auto;
}
</style>
